
require('../scss/index.scss');
require('chosen-js');
require('../node_modules/chosen-js/chosen.css');

$(document).ready( function(){
	if ($('.search-form').length > 0){
		$('.search-form .chosen-select select').chosen({
			width: "100%"
		});
	}
});

// Start your website!
console.log('Loaded search');


//////////////////
// WEBPACK FOOTER
// ./js/index.js
// module id = 3
// module chunks = 0